import { FC } from 'react'
import { IAction, IMessage } from '@/context/types'

import useMessenger from '@/hooks/useMessenger'
import { MESSAGE_TYPES, CONVERSATION_STATE } from '@/context/constants'
import useDebounce from '@/hooks/useDebounce'

interface QuickReplyProps {
  message: IMessage
}

const QuickReply: FC<QuickReplyProps> = ({ message }) => {
  const {
    sendMessage,
    getSelectedConversation,
    getConfig,
    getConversationState,
  } = useMessenger()

  const isConversationNew =
    getConversationState(getSelectedConversation()) === CONVERSATION_STATE.NEW

  const handleOnClick = (action: IAction) => {
    const { text, payload } = action

    const sendPayload = {
      type: MESSAGE_TYPES.MESSAGE,
      conversationId: getSelectedConversation(),
      author: {
        type: getConfig()?.userType,
        userExternalId: getConfig()?.userExternalId,
      },
      content: {
        type: 'text',
        text,
        payload,
      },
      metadata: {
        source: 'poplar-messenger',
      },
    }

    sendMessage(sendPayload)
  }

  return (
    <div>
      {message.content?.actions?.length > 0 && (
        <div className="pmui-flex pmui-w-full pmui-justify-end">
          <div>
            <div className="pmui-text-sm pmui-mb-2">
              {message.content?.text}
            </div>
            {message.content?.actions.map((action: IAction) => {
              return (
                <button
                  key={`${message.id}-${action.text}`}
                  className="quick-reply-btn btn-outlined btn-secondary pmui-ml-4 pmui-rounded-full pmui-px-4 hover:pmui-bg-gray-50"
                  disabled={!isConversationNew}
                  onClick={useDebounce(
                    () => handleOnClick(action),
                    getConfig()?.debounceTimeout,
                  )}
                >
                  {action.text}
                </button>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default QuickReply
